module.exports = __webpack_public_path__ + "img/horizontal_6_2_7042.3d9b3efd.png";